import ProjectData from "@/data/ProjectData.ts";

export default [
  new ProjectData(
    "mfv-fantasy",
    "MFV Fantasy Sports League",
    "img/projects/mfv-fantasy-icon.png",
    `
    <div class="paragraph">
      <strong>MFV Fantasy Sports League</strong> - A multi‑league fantasy platform (live). Built with Next.js, React and TypeScript and deployed on Vercel.
    </div>

    <div class="paragraph center">
      <a href="https://mfvfantasy.vercel.app/" target="_blank" class="view-project-btn">Visit Live Site →</a>
    </div>

    <div class="paragraph">
      <strong>Tech summary</strong>
      <ul>
        <li>Core: Next.js 15 (App Router)</li>
        <li>Styling: Tailwind CSS</li>
        <li>Backend: Supabase (Postgres, Auth, Realtime) + Supabase Edge Functions</li>
        <li>APIs: Yahoo Fantasy, FPL, plus custom API routes</li>
        <li>Data: PapaParse for CSV import/processing</li>
      </ul>
    </div>

    <div class="paragraph">
      <strong>Key features</strong>
      <ul>
        <li>League management, team/schedule/standings tools</li>
        <li>Live stats and realtime updates</li>
        <li>Multi‑sport support (EPL, UCL, MLB) and multiple formats</li>
        <li>CSV data workflows, server/client components, and Vercel deployment</li>
      </ul>
    </div>

    <div class="paragraph">
      <div class="notice">
        <strong>Architecture</strong> — Next.js App Router, server components, REST API routes, Supabase realtime backend. Fast CI/CD on Vercel.
      </div>
    </div>
    `,
    "#4CAF50",
    false,
    true
  ),
];
